import React from "react";
import { FiClock, FiTrendingUp, FiUsers } from "react-icons/fi";
import SummaryCard from "../../SummaryCard";

const TimesheetSummaryCards = ({
  totalEmployees,
  totalHours,
  averageHours,
}) => {
  const cards = [
    {
      title: "พนักงานทั้งหมด",
      value: totalEmployees,
      icon: <FiUsers size={18} />,
      variant: "indigo",
    },
    {
      title: "ชั่วโมงรวม",
      value: totalHours,
      icon: <FiClock size={18} />,
      variant: "yellow",
    },
    {
      title: "ชั่วโมงเฉลี่ย / คน",
      value: averageHours,
      icon: <FiTrendingUp size={18} />,
      variant: "green",
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {cards.map((card) => (
        <SummaryCard key={card.title} {...card} />
      ))}
    </div>
  );
};

export default TimesheetSummaryCards;
